export default "__VITE_ASSET__BvTHbk9C__"